import React from 'react';
import CustomerImportScreen from '../../../src/screens/CustomerImportScreen';
export default function OwnerCustomerImport() { return <CustomerImportScreen />; }
